/*
 * Copyright (c) 2020.  Rikesh Lal Shrestha
 * All Rights Reserved
 */

export const REVIEW_CLEAN_REQUEST = 'REVIEW_CLEAN_REQUEST';

export const REVIEW_ADD_REQUEST = 'REVIEW_ADD_REQUEST';
export const REVIEW_ADD_REQUEST_SUCCESS = 'REVIEW_ADD_REQUEST_SUCCESS';
export const REVIEW_ADD_REQUEST_FAILURE = 'REVIEW_ADD_REQUEST_FAILURE';

export const REVIEW_FETCH_REQUEST = 'REVIEW_FETCH_REQUEST';
export const REVIEW_FETCH_REQUEST_SUCCESS = 'REVIEW_FETCH_REQUEST_SUCCESS';
export const REVIEW_FETCH_REQUEST_FAILURE = 'REVIEW_FETCH_REQUEST_FAILURE';

export const SINGLE_REVIEW_PROCESS_REQUEST = 'SINGLE_REVIEW_PROCESS_REQUEST';
export const SINGLE_REVIEW_PROCESS_REQUEST_SUCCESS = 'SINGLE_REVIEW_PROCESS_REQUEST_SUCCESS';
export const SINGLE_REVIEW_PROCESS_REQUEST_FAILURE = 'SINGLE_REVIEW_PROCESS_REQUEST_FAILURE';

export const SINGLE_REVIEW_CLEAN_REQUEST = 'SINGLE_REVIEW_CLEAN_REQUEST';

export const REVIEW_REASSIGN_REQUEST = 'REVIEW_REASSIGN_REQUEST';
export const REVIEW_REASSIGN_REQUEST_SUCCESS = 'REVIEW_REASSIGN_REQUEST_SUCCESS';
export const REVIEW_REASSIGN_REQUEST_FAILURE = 'REVIEW_REASSIGN_REQUEST_FAILURE';
